
import { Component, Prop, Vue } from "vue-property-decorator";
import GiftListToggle from "./GiftListToggle.vue";
import GiftListPanel from "./GiftListPanel.vue";

@Component({
	components: {
		GiftListToggle,
		GiftListPanel,
	},
})
export default class GiftList extends Vue {
	@Prop() private giftList: string[];

	giftListEnabled: boolean = true;
	showGiftListPanel: boolean = false;
	giftListPanelOpen: boolean = false;
	showGiftListToggle: boolean = true;
	$giftFinder: Element | null;
	isResizing = false;

	created() {
		console.log("$bus", this.$bus);
		this.showGiftListToggle = !!this.giftList.length;
		this.$bus.$on("epoqScrollToGiftFinder", () => {
			console.log("scroll to gift finder");
			this.scrollToGiftFinder();
		});
		this.$bus.$on("epoqOpenGiftList", () => {
			console.log("open gift list event");
			this.openGiftList();
		});
		this.$bus.$on("epoqCloseGiftList", () => {
			console.log("close gift list event");
			this.closeGiftList();
		});
	}

	mounted() {
		// Register an event listener when the Vue component is ready
		window.addEventListener("resize", this.onResize);
	}

	beforeDestroy() {
		// Unregister the event listener before destroying this Vue instance
		window.removeEventListener("resize", this.onResize);
	}

	get isGiftListEnabled() {
		return this.giftListEnabled;
	}

	get giftListComputed() {
		return this.giftList;
	}

	get isGiftFinderPage() {
		return this.$root.$data.isGiftFinderPage;
	}

	get isgiftListPanelOpen() {
		return this.giftListPanelOpen;
	}

	getGiftFinder() {
		return window.document.querySelector("#epoq_giftFinderModal #epoq_widget");
	}

	openGiftList() {
		console.log("opened");
		this.$giftFinder = this.getGiftFinder();
		if (this.$giftFinder) {
			this.$giftFinder.classList.add("epoq-giftlist--has-open-panel");
		}
		this.showGiftListPanel = true;
		this.$nextTick(() => {
			this.giftListPanelOpen = true;
			setTimeout(() => {
				window.dispatchEvent(new Event("resize"));
			}, 600);
		});
	}

	closeGiftList() {
		console.log("closed");
		this.giftListPanelOpen = false;
		this.$giftFinder = this.getGiftFinder();
		if (this.$giftFinder) {
			this.$giftFinder.classList.remove("epoq-giftlist--has-open-panel");
		}
	}

	removeGiftList() {
		console.log("removed");
		this.closeGiftList();
		setTimeout(() => {
			this.giftListEnabled = false;
		}, 600);
	}

	scrollToGiftFinder() {
		this.closeGiftList();
		let $giftFinder = window.document.getElementById("epoq_geschenkefinder");

		if ($giftFinder !== null) {
			$giftFinder.scrollIntoView({ behavior: "smooth" });
		}
	}

	onResize(event) {
		this.isResizing = true;
		console.log("window has been resized", event);
		setTimeout(() => {
			this.isResizing = false;
		}, 500);
	}
}
